import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Box, Chip, Container, Typography } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ViewProfile from "./ViewProfile";
import AccessAndPermissions from "./AccessAndPermissions";
import AssociateCDMOs from "./AssociateCDMOs";
import AssociateBrands from "./AssociateBrands";
import LoginSecurity from "./LoginSecurity";
import Cover from "./Cover";
const useStyles = makeStyles({
  coverContainer: {
    position: "relative",
    width: "100%",
    // height: "12vh",
  },
  coverImg: {
    width: "100%",
    height: "12vh",
    objectFit: "cover",
  },
  avatar: {
    position: "absolute",
    left: "10%",
    bottom: "-15%",
    transform: "translateX(-50%)",
    width: "50px",
    height: "50px",
    backgroundColor: "#3f51b5",
    // border: "2px solid orange",
  },
  info: {
    display: "flex",
    justifyContent: "space-between",
    gap: "1em",
    marginBottom: "1em",
  },
  chips: {
    width: "100%",
    borderRadius: "5px",
    fontWeight: "bold",
  },
  tabsRoot: {
    minHeight: "20px", // Smaller Tabs
    display: "flex",
    justifyContent: "space-between",
    gap: "1em",
  },
  tabRoot: {
    textTransform: "none",
    minWidth: "auto", // Prevent stretching
    fontSize: "12px", // Reduce font size
    fontWeight: "bold",
    padding: "2px 4px",
    minHeight: "30px", // Control height
    "&.Mui-selected": {
      color: "#1976d2", // Blue color for selected tab
    },
  },
});

export default function ViewDetails({
  user,
  departmentDetails,
  setViewDetailsDrawer,
  ViewDetailsDrawer,
  handleRefresh,
  selectedRole
}) {

  const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState(0);
  const changeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const renderTabContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <ViewProfile
            user={user}
            departmentDetails={departmentDetails}
            setViewDetailsDrawer={setViewDetailsDrawer}
            handleRefresh={handleRefresh}
            selectedRole={selectedRole}
          />
        );
      case 1:
        return (
          <AccessAndPermissions
            user={user}
            setViewDetailsDrawer={setViewDetailsDrawer}
            handleRefresh={handleRefresh}
            selectedRole={selectedRole}
          />
        );

      case 2:
     if (localStorage.getItem("collabType") !== "CMO") {
        return (
          <AssociateBrands
            user={user}
            handleRefresh={handleRefresh}
            ViewDetailsDrawer={ViewDetailsDrawer}
            setViewDetailsDrawer={setViewDetailsDrawer}
            selectedRole={selectedRole}
          />
        );
      }
      case 3:
        if (localStorage.getItem("collabType") !== "CMO") {
          return (
            <AssociateCDMOs
              user={user}
              handleRefresh={handleRefresh}
              setViewDetailsDrawer={setViewDetailsDrawer}
              selectedRole={selectedRole}
            />
          );
        }
      case 4:
        return <LoginSecurity
          user={user}
          selectedRole={selectedRole}
        />;
      default:
        return null;
    }
  };
  const getChipColor = () => {
    if (user.account_status === "Active") return "#82cc53";
    else if (user.account_status === "Inactive") return "#cc0000";
  };
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{
          marginTop: "2em",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6">{user?.full_name}</Typography>
        <Box className={classes.info}>
          {user?.country && user?.country !== "null" && user?.country !== null && (
            <Chip
              className={classes.chips}
              label={user?.country}
              style={{ backgroundColor: "#c6c6c6" }}
            />
          )}
          <Chip
            className={classes.chips}
            label={`2FA ${user?.two_step_authentication ? "enabled" : "disabled"
              }`}
            style={{ backgroundColor: "#7bc0ff" }}
          />

          {user?.account_status && (
            <Chip
              className={classes.chips}
              label={user?.account_status}
              style={{
                backgroundColor: getChipColor(),
                color: user?.account_status === "Active" ? "black" : "white",
                // backgroundBlendMode: "overlay" /* Important! */,
                // backgroundImage:
                //   "linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))" /* Adjust alpha (0.1) as needed */,
                // color: user?.account_status === "Active" ? "black" : "white",
              }}
            />
          )}
        </Box>
        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={changeTab}
          // indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: classes.tabsRoot }}
        >
          <Tab label="Profile" classes={{ root: classes.tabRoot }} />
          <Tab
            label="Access and Permissions"
            wrapped
            classes={{ root: classes.tabRoot }}
          />
          {localStorage.getItem("collabType") !== "CMO" && (
          <Tab label="Associate Brands" classes={{ root: classes.tabRoot }} />
          )}
          {localStorage.getItem("collabType") !== "CMO" && (
            <Tab label="Associate CMOs" classes={{ root: classes.tabRoot }} />
          )}
          <Tab label="Login Security" classes={{ root: classes.tabRoot }} />
        </Tabs>
        <Box style={{ marginTop: "1em", flexGrow: 1 }}>
          {renderTabContent()}
        </Box>
      </Container>
    </Box>
  );
}
